'use client';
import { Accordion } from '@curology/ui-components-web/react/Accordion';
import { AccordionContent } from '@curology/ui-components-web/react/Accordion/AccordionContent';
import { AccordionSummary } from '@curology/ui-components-web/react/Accordion/AccordionSummary';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React, { useState } from 'react';

import ExamplePhoto from './examplePhoto';
import PhotoUploader from './photoUploader';
import { type PhotoUploader as PhotoUploaderType } from '../types/types';

const PhotoUploadAccordion = ({
  title,
  uploader,
}: {
  title: string;
  uploader: PhotoUploaderType;
}) => {
  const [open, setOpen] = useState(uploader.required);

  return (
    <Accordion className="cur-bg-surface-neutral cur-my-4" open={open}>
      <AccordionSummary
        className="cur-border-t-0 cur-p-2"
        onClick={() => setOpen(!open)}
      >
        <div className="cur-flex cur-items-center cur-justify-between">
          <Typography data-testid="photo-accordion-title" weight="bold">
            {title}
          </Typography>
          <Typography
            data-testid="photo-accordion-required-or-optional"
            size="meta"
          >
            {uploader.required ? 'Required' : 'Optional'}
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionContent className="cur-border-solid cur-border-t cur-border-t-curology-primary cur-m-0 cur-p-4">
        <div className="cur-grid cur-grid-cols-2 cur-gap-4">
          <ExamplePhoto uploader={uploader} />
          <PhotoUploader uploader={uploader} />
        </div>
      </AccordionContent>
    </Accordion>
  );
};

export default PhotoUploadAccordion;
